import React, { Children } from 'react';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
import { theme } from '../../theme/theme';
/**
 * @public
 */
export const RelatedComponent = ({
  name,
  desc,
  children,
  onClick
}) => React.createElement(Box, {
  onClick: onClick,
  style: {
    cursor: 'pointer'
  }
}, React.createElement(Box, {
  bg: 'background.light',
  borderRadius: 'xl',
  p: 3,
  style: {
    display: 'grid',
    placeItems: 'center',
    aspectRatio: '2.5'
  }
}, children), React.createElement(Text, {
  textStyle: 'heading5',
  py: 2
}, name), desc && React.createElement(Text, null, desc));
/**
 * @public
 */
export const RelatedComponentContainer = ({
  children
}) => React.createElement(Box, {
  style: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: `repeat(${Children.count(children)}, 1fr)`,
    gap: theme.space[3]
  }
}, children);